import { useSearchParams } from 'react-router-dom';

const EDIT_QUERY = 'edit';
export function useEditGame() {
    const [searchParams, setSearchParams] = useSearchParams();
    const isEditing = Boolean(searchParams.get(EDIT_QUERY));

    function toggleEdit() {
        if (isEditing) {
            searchParams.delete(EDIT_QUERY);
        } else {
            searchParams.set(EDIT_QUERY, 'edit');
        }
        setSearchParams(searchParams);
    }

    return { toggleEdit, isEditing };
}
